import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function FacebookShareIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.35 13.653H16.59L18.21 8.69397H13.35V6.53172C13.35 4.58922 13.758 3.60672 16.59 3.73422H18.21V0.428223C17.8463 0.540723 14.979 0.428223 13.35 0.428223C10.497 0.428223 8.14875 2.75322 8.49 7.04097V8.69397H5.25V13.653H8.49V23.571H13.35V13.653Z"
        fill="inherit"
      />
    </SvgIcon>
  );
}
